// Public, opaque paths only. Account attribution lives on the server.
export const WAITLIST_PATHS = [
  "/r7k2", "/m9v4",
  "/1gzh6a", "/2qdfj7", "/5qz8pf", "/64zrgy", "/859dlu", "/86l6ez",
  "/8w96ij", "/a806pn", "/b66704", "/bal03o", "/c97zx9", "/cg5kg0",
  "/ciyobw", "/co00ii", "/emgff9", "/enkk49", "/fctze2", "/fdv3pj",
  "/fvc2ye", "/gpvzw3", "/gv8le9", "/h5q6na", "/i8k5l1", "/jglyjo",
  "/k8yymv", "/k9x4m3", "/k9xjzw", "/kfb1hr", "/l83jw5", "/mwqhm7",
  "/ntjicl", "/p362lb", "/pwrv79", "/qmh1d9", "/rpculw", "/ry6w2z",
  "/scxun7", "/szxdbo", "/tksq1r", "/u84q20", "/uskdpv", "/v7h4c6",
  "/wt48o2", "/wtq31e", "/xhnhel", "/xuc6ma", "/xx64ev", "/yms1kn",
] as const;
export function isWaitlistPath(path: string) {
  const clean = path.split("?")[0].replace(/\/+$/, "");
  return clean === "/early-access" || WAITLIST_PATHS.some(p => p === clean);
}
